import { UserPermissionCodes } from "@odata/CompanyPermissionEnums";
import { EntityTypeName } from "@odata/GeneratedEntityTypes";
import React, { lazy } from "react";

import {
    ROUTE_BANK_ACCOUNTS,
    ROUTE_BANK_STATEMENTS,
    ROUTE_BANK_TRANSACTIONS,
    ROUTE_CASH_BOXES,
    ROUTE_CASH_RECEIPTS,
    ROUTE_LOAN_ACCOUNTS,
    ROUTE_LOAN_STATEMENTS,
    ROUTE_LOAN_TRANSACTIONS
} from "../routes";
import FormDynamicEntityRoute from "../routes/FormDynamicEntityRoute";
import FormRoute from "../routes/FormRoute";

const BankStatements = lazy(() => import(/* webpackChunkName: "bank" */"../pages/banks/bankStatements/BankStatements"));
const BankTransactions = lazy(() => import(/* webpackChunkName: "bank" */"../pages/banks/bankTransactions/BankTransactions"));
const BankAccounts = lazy(() => import(/* webpackChunkName: "bank" */"../pages/banks/bankAccounts/BankAccounts"));
const CashBoxes = lazy(() => import(/* webpackChunkName: "bank" */"../pages/cashBoxes/CashBoxes"));
const CashReceipts = lazy(() => import(/* webpackChunkName: "bank" */"../pages/cashBoxes/cashReceipts/CashReceipts"));
const LoanAccounts = lazy(() => import(/* webpackChunkName: "bank" */"../pages/loans/accounts/LoanAccounts"));
const LoanStatements = lazy(() => import(/* webpackChunkName: "bank" */"../pages/loans/statements/LoanStatements"));
const LoanTransactions = lazy(() => import(/* webpackChunkName: "bank" */"../pages/loans/transactions/LoanTransactions"));

export default function bankBundle(): React.ReactElement[] {
    return [
        <FormRoute
            path={ROUTE_BANK_STATEMENTS}
            key={ROUTE_BANK_STATEMENTS}
            entityType={EntityTypeName.BankStatement}
            CPs={UserPermissionCodes.Bank}
            page={BankStatements}/>,

        <FormRoute
            path={ROUTE_BANK_TRANSACTIONS}
            key={ROUTE_BANK_TRANSACTIONS}
            entityType={EntityTypeName.BankTransaction}
            CPs={UserPermissionCodes.Bank}
            page={BankTransactions}/>,

        <FormRoute
            path={ROUTE_BANK_ACCOUNTS}
            key={ROUTE_BANK_ACCOUNTS}
            entityType={EntityTypeName.CompanyBankAccount}
            CPs={UserPermissionCodes.MasterData}
            page={BankAccounts}/>,

        <FormRoute
            path={ROUTE_CASH_BOXES}
            key={ROUTE_CASH_BOXES}
            entityType={EntityTypeName.CashBox}
            CPs={UserPermissionCodes.MasterData}
            page={CashBoxes}/>,

        <FormDynamicEntityRoute
            path={ROUTE_CASH_RECEIPTS}
            key={ROUTE_CASH_RECEIPTS}
            CPs={UserPermissionCodes.CashBox}
            page={CashReceipts}/>,

        <FormRoute
            path={ROUTE_LOAN_ACCOUNTS}
            key={ROUTE_LOAN_ACCOUNTS}
            entityType={EntityTypeName.LoanAccount}
            CPs={UserPermissionCodes.Bank}
            page={LoanAccounts}/>,

        <FormRoute
            path={ROUTE_LOAN_STATEMENTS}
            key={ROUTE_LOAN_STATEMENTS}
            entityType={EntityTypeName.LoanStatement}
            CPs={UserPermissionCodes.Bank}
            page={LoanStatements}/>,

        <FormRoute
            path={ROUTE_LOAN_TRANSACTIONS}
            key={ROUTE_LOAN_TRANSACTIONS}
            entityType={EntityTypeName.LoanTransaction}
            CPs={UserPermissionCodes.Bank}
            page={LoanTransactions}/>

    ];
}